export const confereClicados = (sshdLogado, rotas) => {
  let clicados = [];
  if (!localStorage.clicados) {
    criaClicados(clicados, sshdLogado);
  }
  clicados = JSON.parse(localStorage.getItem("clicados"));
  const existeLogado = clicados.some((item) => item.sshd === sshdLogado);
  if (!existeLogado) {
    criaClicados(clicados, sshdLogado);
  }
  const clicksDoLogado = clicados.find((item) => item.sshd === sshdLogado);
  if (!clicksDoLogado.links.length) {
    criaClicadosUsuario(sshdLogado, clicados, rotas);
  } else {
    atualizaClicados(JSON.parse(localStorage.getItem("clicados")), sshdLogado, rotas);
  }
};

export const contaCliques = (link, sshdLogado) => {
  if (localStorage.clicados) {
    let clicados = JSON.parse(localStorage.getItem("clicados"));
    let clicadosDoLogado = clicados.find((item) => item.sshd === sshdLogado);
    if (clicadosDoLogado) {
      clicadosDoLogado.links.forEach((clicado) => {
        if (clicado.name === link.name) {
          clicado.cliques++;
        }
      });
      salvaMudancas(clicadosDoLogado, clicados, sshdLogado);
    }
  }
};

const criaClicados = (clicados, sshdLogado) => {
  const clicksDoLogado = { sshd: sshdLogado, links: [] };
  clicados.push(clicksDoLogado);
  localStorage.setItem("clicados", JSON.stringify(clicados));
};

const criaClicadosUsuario = (sshdLogado, clicados, rotas) => {
  const clicksDoLogado = { sshd: sshdLogado, links: [] };
  rotas.forEach((rota) => {
    if (rota.meta && rota.meta.contavel) {
      let card = {};
      card.cliques = 1;
      card.meta = rota.meta;
      card.name = rota.name;
      clicksDoLogado.links.push(card);
    }
  });
  const indexDoLogado = clicados.findIndex((item) => item.sshd == sshdLogado);
  clicados.splice(indexDoLogado, 1, clicksDoLogado);
  localStorage.setItem("clicados", JSON.stringify(clicados));
};

const atualizaClicados = (clicados, sshdLogado, rotas) => {
  const linksAtualizados = []
  const clicksDoLogado = clicados.find((item) => item.sshd === sshdLogado);
  const rotasClicaveis = rotas.filter((rota) => rota.meta && rota.meta.contavel);

  rotasClicaveis.forEach((rota) => {
    let card = {}
    card.meta = rota.meta;
    card.name = rota.name;
    let existente = clicksDoLogado.links.find(link => link.name === rota.name);
    card.cliques = !!existente ? existente.cliques : 1;
    linksAtualizados.push(card);
  })

  clicksDoLogado.links = [...linksAtualizados];

  salvaMudancas(clicksDoLogado, clicados, sshdLogado);
};

const salvaMudancas = (rotasDoLogado, clicados, sshdLogado) => {
  rotasDoLogado.links = rotasDoLogado.links.sort(
    (a, b) => b.cliques - a.cliques
  );
  const clicadosLocalIndex = clicados.findIndex(
    (item) => item.sshd === sshdLogado
  );
  clicados.splice(clicadosLocalIndex, 1, rotasDoLogado);
  localStorage.setItem("clicados", JSON.stringify(clicados));
};



// WEBPACK FOOTER //
// ./src/router/favoritos.js